export enum SpoergsmaalType {
    Multi = 1,
    Tekst = 2,
    Dato = 3,
    Nummer = 4,
    Boolean = 5,
    DatoOgGodkendt = 6
}
